import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';  // 1) import useNavigate
import axiosInstance from '../axiosConfig';

function Join() {
  const navigate = useNavigate(); // 2) create navigate function

  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    username: '',
    email: '',
    password: '',
    password2: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
    setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    axiosInstance.post('/api/v1/join/', formData)
      .then(response => {
        // 3) Navigate back to root on success
        navigate('/');
      })
      .catch(error => {
        if (error.response && error.response.data) {
          setErrors(error.response.data);
        } else {
          console.error('An unexpected error occurred:', error);
        }
      });
  };

  return (
    <div className="container">
      <div className="jumbotron">
        <h1>Join</h1>
        <form onSubmit={handleSubmit} noValidate>
          {/* First Name */}
          <div className="form-group">
            <label htmlFor="id_first_name">First name:</label>
            <input
              type="text"
              className={`form-control ${errors.first_name ? 'is-invalid' : ''}`}
              name="first_name"
              id="id_first_name"
              value={formData.first_name}
              onChange={handleChange}
            />
            {errors.first_name && <div className="invalid-feedback">{errors.first_name}</div>}
          </div>

          {/* Last Name */}
          <div className="form-group">
            <label htmlFor="id_last_name">Last name:</label>
            <input
              type="text"
              className={`form-control ${errors.last_name ? 'is-invalid' : ''}`}
              name="last_name"
              id="id_last_name"
              value={formData.last_name}
              onChange={handleChange}
            />
            {errors.last_name && <div className="invalid-feedback">{errors.last_name}</div>}
          </div>

          {/* Username */}
          <div className="form-group">
            <label htmlFor="id_username">Username:</label>
            <input
              type="text"
              className={`form-control ${errors.username ? 'is-invalid' : ''}`}
              name="username"
              id="id_username"
              value={formData.username}
              onChange={handleChange}
              required
            />
            {errors.username && <div className="invalid-feedback">{errors.username}</div>}
          </div>

          {/* Email */}
          <div className="form-group">
            <label htmlFor="id_email">Email:</label>
            <input
              type="email"
              className={`form-control ${errors.email ? 'is-invalid' : ''}`}
              name="email"
              id="id_email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
          </div>

          {/* Password */}
          <div className="form-group">
            <label htmlFor="id_password">Password:</label>
            <input
              type="password"
              className={`form-control ${errors.password ? 'is-invalid' : ''}`}
              name="password"
              id="id_password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            {errors.password && <div className="invalid-feedback">{errors.password}</div>}
          </div>

          {/* Confirm Password */}
          <div className="form-group">
            <label htmlFor="id_password2">Confirm Password:</label>
            <input
              type="password"
              className={`form-control ${errors.password2 ? 'is-invalid' : ''}`}
              name="password2"
              id="id_password2"
              value={formData.password2}
              onChange={handleChange}
              required
            />
            {errors.password2 && <div className="invalid-feedback">{errors.password2}</div>}
          </div>

          {/* Non-field Errors */}
          {errors.non_field_errors && errors.non_field_errors.map((error, index) => (
            <div key={index} className="alert alert-danger">
              {error}
            </div>
          ))}

          {/* Submit Button */}
          <button type="submit" className="btn btn-primary">Join</button>
        </form>
      </div>
    </div>
  );
}

export default Join;
